/**
 * handleCallback.js
 *
 * Copyright (c) apploft. GmbH
 */

import {authorizationFailed, authorizationSucceeded} from '../PortalEventSymbol';
import {authorizingCallback, unauthorized} from '../PortalStateSymbol';

export default function handleCallback({authService, dispatch, controller}) {
  // TODO support aborting? Does oidc-client support this in principle?
  if (authService) {
    const callbackResult = authService.handleCallback();
    if (callbackResult) {
      callbackResult
        .then(user => dispatch({event: authorizationSucceeded, payload: {
          keyAdminAuth: `Bearer ${user.id_token}`,
        }}))
        .catch(error => dispatch({event: authorizationFailed, payload: error}));
    } else {
      return {state: unauthorized};
    }
  }
  return {state: authorizingCallback, controller};
}
